import { useQuery } from '@tanstack/react-query';
import { useEntity } from '@/hooks/useEntity';
import { getUpcomingInvoice } from '../api/billing.api';
import { billingKeys } from './billing.keys';

/**
 * The next renewal invoice, from Stripe's preview; null when nothing renews.
 * Split out of the retired seat-billing hooks (v1.2, FR-41 seat add-ons
 * withdrawn): the renewal estimate is a billing read, not a seat one.
 *
 * @param enabled - only while a renewal is due, so a lapsed plan asks nothing
 */
export function useUpcomingInvoice(enabled: boolean) {
  const entityId = useEntity()?.entityId;
  return useQuery({
    queryKey: [...billingKeys.all, 'upcomingInvoice', entityId ?? 'none'],
    queryFn: () => getUpcomingInvoice(entityId as string),
    enabled: enabled && Boolean(entityId),
  });
}
